export const RUN_ACTIVE_STATUSES = ['running', 'scheduled', 'paused']

export const RUN_LIVE_STATUSES = ['running', 'scheduled']

export const isRunFinished = (status: string): boolean => !RUN_ACTIVE_STATUSES.includes(status)

const RUN_STATUS_LABELS: Record<string, string> = {
  succeeded: 'Succeeded',
  failed: 'Failed',
  stopped: 'Stopped',
  'partial-succeeded': 'Partially succeeded',
  running: 'Running',
  scheduled: 'Scheduled',
  paused: 'Waiting for input',
}

const humaniseStatus = (status: string): string => {
  const spaced = status.replace(/[-_]+/g, ' ').trim()
  return spaced ? spaced.charAt(0).toUpperCase() + spaced.slice(1) : spaced
}

export const runStatusLabel = (status: string): string => RUN_STATUS_LABELS[status] ?? humaniseStatus(status)
